import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Button } from 'foundations-components/transitional/components/Button';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { useCallback, useState } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { MacrosMenuLoadingState } from './MacrosMenuLoadingState';
import { MacrosMenuErrorState } from './MacrosMenuErrorState';
import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { LockedIcon } from 'foundations-assets';
import { useUpgradePoint } from 'ui-addon-upgrades/ums/useUpgradePoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ADMIN_MACROS_SETTINGS_URL = `${getFullUrl('app')}/helpdesk-settings/${PortalIdParser.get()}/inboxes/macros`;
const MacrosIntroContent = ({
  ButtonComponent
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "bolt"
    }), /*#__PURE__*/_jsxs(View, {
      alignSelf: "center",
      textAlign: "center",
      marginBlock: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        as: "strong",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.macros-menu.zero-state.title"
        })
      }), /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.macros-menu.zero-state.body"
        })
      })]
    }), ButtonComponent]
  });
};
MacrosIntroContent.displayName = 'MacrosIntroContent';
export const MacrosEmptyStatePopover = ({
  isAdmin,
  hasMacrosScope,
  loading,
  error,
  macros,
  portalIsEnterprise
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    openUpgradePage
  } = useUpgradePoint('hd-macros');
  const renderPopoverContent = useCallback(() => {
    if (loading) {
      return /*#__PURE__*/_jsx(MacrosMenuLoadingState, {});
    }
    if (error) {
      return /*#__PURE__*/_jsx(MacrosMenuErrorState, {});
    }
    if (macros.length === 0 && isAdmin && hasMacrosScope) {
      return /*#__PURE__*/_jsx(MacrosIntroContent, {
        ButtonComponent: /*#__PURE__*/_jsx(Button, {
          use: "tertiary",
          size: "default",
          href: ADMIN_MACROS_SETTINGS_URL,
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.macros-menu.zero-state.admin-create-button"
          })
        })
      });
    }
    if (!portalIsEnterprise) {
      return /*#__PURE__*/_jsx(MacrosIntroContent, {
        ButtonComponent: /*#__PURE__*/_jsxs(Button, {
          use: "secondary",
          size: "default",
          onClick: openUpgradePage,
          children: [/*#__PURE__*/_jsx(LockedIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.macros-menu.zero-state.enterprise-upgrade"
          })]
        })
      });
    }
    if (!hasMacrosScope) {
      return /*#__PURE__*/_jsx(MacrosIntroContent, {
        ButtonComponent: /*#__PURE__*/_jsxs(Button, {
          use: "secondary",
          size: "default",
          onClick: openUpgradePage,
          children: [/*#__PURE__*/_jsx(LockedIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.macros-menu.zero-state.purchase-seat"
          })]
        })
      });
    }
  }, [loading, error, macros.length, isAdmin, hasMacrosScope, portalIsEnterprise, openUpgradePage]);
  const adminMustCreateMacro = macros.length === 0 && !loading && !error && !isAdmin && hasMacrosScope;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: I18n.text('composer-ui.macros-menu.no-macros'),
    disabled: !adminMustCreateMacro,
    children: /*#__PURE__*/_jsx(Popover, {
      open: isOpen,
      onOpenChange: e => setIsOpen(e.currentTarget.value),
      content: /*#__PURE__*/_jsx(Flex, {
        "data-test-id": "macros-empty-state-popover-content",
        blockSize: "300px",
        inlineSize: "340px",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        children: renderPopoverContent()
      }),
      children: /*#__PURE__*/_jsx(Button, {
        use: "transparent",
        size: "default",
        onClick: () => setIsOpen(!isOpen),
        disabled: adminMustCreateMacro,
        "data-test-id": "macros-empty-state-popover",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.macros-menu.title"
        })
      })
    })
  });
};
MacrosEmptyStatePopover.displayName = 'MacrosEmptyStatePopover';